
import Vue from 'vue';
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {Prop} from "vue-property-decorator";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

const lockerModule = namespace("lockerModule");
const serviceProviderModule = namespace("serviceProviderModule");

@Component({
  components: {
    SimpleConfirmationDialog,
  },
})
export default class ServiceProviderActiveWidget extends Vue {

  @serviceProviderModule.Action('setActive')
  setActive!: (data: any) => Promise<any>;

  @Prop({default: false})
  protected item!: IShortServiceProvider;

  protected showActiveConfirmation: boolean = false;
  protected setActiveConfirmationProvider: IShortServiceProvider = {} as IShortServiceProvider;

  created() {
  }

  protected onActiveClicked(serviceProvider: IShortServiceProvider) {
    this.showActiveConfirmation = true;
    this.setActiveConfirmationProvider = serviceProvider;
  }

  protected onActiveConfirmed() {
    this.showActiveConfirmation = false;
    this.setActive({
      serviceProviderId: this.setActiveConfirmationProvider.id,
      active: !this.setActiveConfirmationProvider.active
    });
  }

}

